import StudentExam from './student-exam';
import { StudentExamType } from '../../api/student-exam';
import Segment from '../shared/segment';

export type ExamListPropsType = {
  studentExams: StudentExamType[];
};

function StudentExamList({ studentExams }: ExamListPropsType) {
  return (
    <>
      {studentExams.length === 0 && <Segment textAlign='center'>نتیجه ای یافت نشد.</Segment>}
      <div className='grid sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4'>
        {studentExams.map(studentExam => (
          <StudentExam key={studentExam.id} studentExam={studentExam} />
        ))}
      </div>
    </>
  );
}

export default StudentExamList;
